var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex" },
    [
      _c(
        "b-button",
        {
          staticClass:
            "py-0 mx-0 d-flex align-items-center justify-content-center mr-2 p-0",
          staticStyle: { height: "40px", width: "119.664px" },
          attrs: {
            id: "tank-orien-horz",
            block: "",
            variant: "no-outline",
            "data-test-hook":
              "tank-enrollment-step-3-tank-orientation-horizontal-button"
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.goToAppleStore.apply(null, arguments)
            }
          }
        },
        [
          _c("b-img", {
            staticClass: "mx-auto d-block mt-3",
            staticStyle: { "object-fit": "fill" },
            attrs: {
              src: require("@/assets/images/DownloadOnAppStore-Badge-Web.svg"),
              "data-test-hook":
                "tank-enrollment-step-3-tank-orientation-horizontal-image"
            }
          })
        ],
        1
      ),
      _c(
        "b-button",
        {
          staticClass:
            "py-0 mx-0 d-flex align-items-center justify-content-center mr-2 p-0",
          staticStyle: {
            height: "40px",
            width: "135px",
            "aspect-ratio": "27/8"
          },
          attrs: {
            id: "tank-orien-horz",
            block: "",
            variant: "no-outline",
            "data-test-hook":
              "tank-enrollment-step-3-tank-orientation-horizontal-button"
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.goToGoogleStore.apply(null, arguments)
            }
          }
        },
        [
          _c("b-img", {
            staticClass: "mx-auto d-block",
            staticStyle: { "object-fit": "fill" },
            attrs: {
              src: require("@/assets/images/GetItOnGooglePlay-Badge-Web.svg"),
              "data-test-hook":
                "tank-enrollment-step-3-tank-orientation-horizontal-image"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }